import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Card, CardContent } from '../../../components/ui/card';
import { Copy, Download, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ExportPanel({ callId }) {
  const [format, setFormat] = useState('markdown');
  const [content, setContent] = useState('');
  const [filename, setFilename] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async (fmt) => {
    setFormat(fmt);
    setLoading(true);
    try {
      const res = await axios.get(`${API}/triage/calls/${callId}/export`, { params: { format: fmt } });
      setContent(res.data.content || '');
      setFilename(res.data.filename || `triage.${fmt === 'json' ? 'json' : 'md'}`);
    } catch (e) {
      toast.error('Failed to load export');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { load('markdown'); /* eslint-disable-next-line */ }, [callId]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      toast.success('Copied to clipboard');
    } catch (e) {
      toast.error('Copy failed');
    }
  };

  const download = () => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Button variant={format === 'markdown' ? 'default' : 'outline'} size="sm"
          onClick={() => load('markdown')}
          className={format === 'markdown' ? 'bg-[#00d4aa] text-black' : 'border-white/10 text-white/70'}>
          Markdown
        </Button>
        <Button variant={format === 'json' ? 'default' : 'outline'} size="sm"
          onClick={() => load('json')}
          className={format === 'json' ? 'bg-[#00d4aa] text-black' : 'border-white/10 text-white/70'}>
          JSON
        </Button>
        <div className="flex-1" />
        <Button size="sm" variant="outline" onClick={copy} className="border-white/10 text-white/70">
          <Copy className="w-3.5 h-3.5 mr-1.5" /> Copy
        </Button>
        <Button size="sm" variant="outline" onClick={download} className="border-white/10 text-white/70">
          <Download className="w-3.5 h-3.5 mr-1.5" /> Download
        </Button>
      </div>

      <Card className="bg-black/30 border-white/10">
        <CardContent className="p-4">
          {loading ? (
            <div className="flex items-center justify-center py-8 text-white/40">
              <Loader2 className="w-5 h-5 animate-spin" />
            </div>
          ) : (
            <pre className="text-xs text-white/80 whitespace-pre-wrap font-mono max-h-[420px] overflow-auto">
              {content}
            </pre>
          )}
        </CardContent>
      </Card>
      <p className="text-xs text-white/40">Paste the GHL note section straight into the contact in GoHighLevel.</p>
    </div>
  );
}

export default ExportPanel;
